import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-105c60e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 3,
  style: {"display":"flex","gap":"12px","width":"100%"}
}

import {
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseInput,
  BaseInputProps,
  BaseSelect,
  BaseSelectProps,
  BaseUpload,
  XrkMessage
} from 'xrk-components';
import { ref } from 'vue';
import { Drug } from '../../data-source/types';
import { getProductOtherInfo } from '../../data-source/api';
import {
  PRODUCT_DRUG,
  PRODUCT_SOURCE_LIBRARY,
  PRODUCT_SOURCE_PROJECT
} from '../../config';
type EditRow = Partial<Drug['row']>;

export default /*#__PURE__*/_defineComponent({
  __name: 'drug-form',
  props: {
    isAdd: { type: Boolean },
    disabled: { type: Boolean },
    row: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const FormRef = ref<BaseFormRef>();

const Reflect = window.Reflect;
const uploadFile = async (file: File) => {
  return URL.createObjectURL(file);
};

const formData = ref<{ [key in keyof typeof props.row]: any }>({
  ...props.row
});
const needDealKeys: Array<keyof EditRow> = [
  'name',
  'productName',
  'medicineType',
  'jixing',
  'scope'
];

const disableKeys = ref<Set<keyof EditRow>>(new Set());
if (
  [PRODUCT_SOURCE_LIBRARY, PRODUCT_SOURCE_PROJECT].includes(props.row.source) ||
  props.isAdd
) {
  disableKeys.value = new Set(needDealKeys);
  if (!props.isAdd) {
    disableKeys.value.add('approvalNumber');
  }
}
if (props.row.isOtcFixed == 1) {
  // 处方药后不能修改
  disableKeys.value.add('isOtc');
}

const _baseInputConfig = { maxlength: 20, clearable: true } as BaseInputProps;

const columns: Array<{
  type?: 'input' | 'img' | 'search' | 'select';
  prop: any;
  label: string;
  required?: boolean;
  config?: any;
  disable?: boolean;
  searchFn?: (searchVal: string | number | undefined) => Promise<void> | void;
}> = [
  {
    prop: 'isOtc',
    label: '是否处方药',
    type: 'select',
    required: true,
    config: {
      options: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      clearable: true
    } as BaseSelectProps
  },
  {
    prop: 'approvalNumber',
    label: '批准文号',
    type: 'search',
    required: true,
    config: _baseInputConfig,
    searchFn: async searchVal => {
      const { data } = await getProductOtherInfo({
        approvalNumber: searchVal,
        type: PRODUCT_DRUG
      });
      const isEmpty = !data || Object.keys(data).length === 0;
      if (isEmpty) XrkMessage.error('暂未查询到信息');
      needDealKeys.forEach(key => {
        if (isEmpty) {
          disableKeys.value.delete(key);
          formData.value[key] = '';
        } else {
          disableKeys.value.add(key);
          formData.value[key] = data?.[key] || '-';
        }
      });
      setTimeout(() => FormRef.value.validateField(needDealKeys), 0);
    }
  },
  {
    prop: 'name',
    label: '药品名称',
    type: 'input',
    required: true,
    config: _baseInputConfig
  },
  {
    prop: 'productName',
    label: '商品名称',
    type: 'input',
    required: true,
    config: _baseInputConfig
  },
  {
    prop: 'medicineType',
    label: '药品类型',
    type: 'input',
    required: true,
    config: _baseInputConfig
  },
  {
    prop: 'jixing',
    label: '剂型',
    type: 'input',
    required: true,
    config: _baseInputConfig
  }
];

const rules = columns.reduce((prev, cur) => {
  prev[cur.prop] = cur.required
    ? [
        {
          required: true,
          message: `请${
            ['input', 'search'].includes(cur.type) ? '输入' : '选择'
          }${cur.label}`,
          trigger: 'blur'
        }
      ]
    : [];
  return prev;
}, {});

__expose({
  getFormData: async () => {
    await FormRef.value.validate();
    const res = { ...formData.value };
    Array.from(disableKeys.value).forEach(key => {
      if (res[key] === '-') {
        res[key] = '';
      }
    });
    return res;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "FormRef",
    ref: FormRef,
    model: formData.value,
    "label-suffix": "：",
    "label-position": "right",
    disabled: _ctx.disabled
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
        return _createVNode(_unref(BaseFormItem), {
          key: item.prop,
          prop: item.prop,
          label: item.label,
          rules: _unref(rules)[item.prop]
        }, {
          default: _withCtx(() => [
            (item.type === 'input')
              ? (_openBlock(), _createBlock(_unref(BaseInput), _mergeProps({
                  key: 0,
                  style: {"width":"100%"},
                  disabled: disableKeys.value.has(item.prop),
                  modelValue: formData.value[item.prop],
                  "onUpdate:modelValue": ($event: any) => ((formData.value[item.prop]) = $event),
                  placeholder: `请输入${item.label}`,
                  ref_for: true
                }, item.config), null, 16, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"]))
              : _createCommentVNode("", true),
            (item.type === 'select')
              ? (_openBlock(), _createBlock(_unref(BaseSelect), _mergeProps({
                  key: 1,
                  style: {"width":"100%"},
                  disabled: disableKeys.value.has(item.prop),
                  modelValue: formData.value[item.prop],
                  "onUpdate:modelValue": ($event: any) => ((formData.value[item.prop]) = $event),
                  placeholder: `请选择${item.label}`,
                  ref_for: true
                }, item.config), null, 16, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"]))
              : _createCommentVNode("", true),
            (item.type === 'img')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.disabled && !formData.value[item.prop])
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "-"))
                    : (_openBlock(), _createBlock(_unref(BaseUpload), {
                        key: 1,
                        style: {"width":"100%"},
                        "file-list": 
            formData.value[item.prop]
              ? [
                  {
                    url: formData.value[item.prop],
                    name: '药品图片',
                    status: 'success',
                    uid: 1
                  }
                ]
              : []
          ,
                        class: _normalizeClass(["custom-upload", { 'has-img': formData.value[item.prop] }]),
                        "auto-upload": "",
                        drag: "",
                        "list-type": "picture-card",
                        "http-request": 
            async ({ file }) => {
              _unref(Reflect).set(formData.value, item.prop, await uploadFile(file));
              _unref(Reflect).set(formData.value, `file_${item.prop}`, file);
            }
          ,
                        "before-remove": 
            () => {
              _unref(Reflect).set(formData.value, item.prop, '');
              return true;
            }
          ,
                        disabled: disableKeys.value.has(item.prop) || _ctx.disabled,
                        accept: ['image/*'],
                        onError: _cache[0] || (_cache[0] = 
            ({ msg }) => {
              _unref(XrkMessage).error(msg);
            }
          ),
                        "before-selected": 
            (() => {
              let show = false;
              return file => {
                if (!file.type) {
                  !show &&
                    (show = true) &&
                    _unref(XrkMessage).error({
                      message: '不支持上传此类文件',
                      onClose: () => (show = false)
                    });
                  throw '不支持上传此类文件';
                }
                return false;
              };
            })()
          
                      }, null, 8, ["file-list", "class", "http-request", "before-remove", "disabled", "before-selected"]))
                ], 64))
              : _createCommentVNode("", true),
            (item.type === 'search')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(BaseInput), _mergeProps({
                    clearable: "",
                    style: {"flex-grow":"1"},
                    disabled: disableKeys.value.has(item.prop),
                    modelValue: formData.value[item.prop],
                    "onUpdate:modelValue": ($event: any) => ((formData.value[item.prop]) = $event),
                    placeholder: `请输入${item.label}`,
                    ref_for: true
                  }, item.config), null, 16, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"]),
                  _createVNode(_unref(BaseButton), {
                    disabled: !formData.value[item.prop] || disableKeys.value.has(item.prop),
                    click: async () => await item.searchFn?.(formData.value[item.prop])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 查询 ")
                    ]),
                    _: 2
                  }, 1032, ["disabled", "click"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["prop", "label", "rules"])
      }), 64))
    ]),
    _: 1
  }, 8, ["model", "disabled"]))
}
}

})